export const REVENUE_ACTION_TYPE = {
	setPeriodData: 'revenue/setPeriodData',
	setAllTimeData: 'revenue/setAllTimeData',
	setPreviousPeriodData: 'revenue/setPreviousPeriodData',
	setLoading: 'revenue/setLoading',
	setExportData: 'revenue/setExportData',
	clearExportData: 'revenue/clearExportData',
	setAllTaxPros: 'revenue/setAllTaxPros',
	setAllUsers : 'revenue/setAllUsers',
	setAllJobs : 'revenue/setAllJobs',
	extendGracePeriodByAdmin: 'revenue/extendGracePeriodByAdmin',
	syncAllFromStripe: 'revenue/syncAllFromStripe',
};
